import { ProviderLayout } from '@/components/layouts/provider-layout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Construction } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ComingSoonProps {
  title: string;
  description?: string;
}

export default function ComingSoon({ title, description }: ComingSoonProps) {
  const { t } = useTranslation();

  return (
    <ProviderLayout>
      <div className="container mx-auto p-6 max-w-4xl">
        <Card className="text-center">
          <CardHeader>
            <Construction className="h-16 w-16 mx-auto text-muted-foreground mb-4" />
            <CardTitle className="text-3xl">{title}</CardTitle>
            {description && (
              <CardDescription className="text-lg">
                {description}
              </CardDescription>
            )}
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              {t('common.comingSoonNotice')}
            </p>
          </CardContent>
        </Card>
      </div>
    </ProviderLayout>
  );
}
